var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loading-bar",class:{done: _vm.done}},[_c('div',{staticClass:"progress",class:_vm.color,style:({ width: _vm.progress+'%' })})])}
var staticRenderFns = []

export { render, staticRenderFns }